import LinearRatesComparisons from "./LinearRatesComparisons";

export default LinearRatesComparisons;
